module.exports = __webpack_public_path__ + "img/chevron-up.81bc4e1f.svg";